import React from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_BUQUES } from '../../../config/forms'
import DialogView from '../../Dialogos/DialogView'
import AgregarBuqueDialogView from './AgregarBuqueDialogView'

function AgregarBuqueDialog (props) {
  const { confirmCallback, cancelCallback } = props

  const handleSubmit = () => {
    const { nombre, nombreCorto, pais, imo } = props
    if (nombre !== '' && nombreCorto !== '') {
      if (pais !== '') {
        if (imo !== '') {
          confirmCallback()
        } else {
          toast.error('Debe ingresar el numero de imo para agregar un buque')
        }
      } else {
        toast.error('Debe ingresar el pais del buque')
      }
    } else if (nombre === '') {
      toast.error('Debe ingresar el nombre del buque a agregar')
    } else if (nombreCorto === '') {
      toast.error('Debe ingresar el nombre corto del buque')
    }
  }

  return (
    <>
      <DialogView
        confirmCallback={handleSubmit}
        cancelCallback={cancelCallback}
        title='Agregar Buque'
        content={
          <AgregarBuqueDialogView />
        }
      />
    </>
  )
}

const selector = formValueSelector(FORM_BUQUES)
const mapStateToProps = (state) => ({
  imo: selector(state, 'imo'),
  nombre: selector(state, 'nombre'),
  nombreCorto: selector(state, 'nombreCorto'),
  pais: selector(state, 'pais')
})

export default reduxForm({
  form: FORM_BUQUES,
  // initialValues: EMPLY_BUQUE,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})(connect(mapStateToProps, null)(AgregarBuqueDialog))
